import { render, staticRenderFns } from "./CustomDatabasePage.vue?vue&type=template&id=63e1cbf4&scoped=true"
import script from "./CustomDatabasePage.vue?vue&type=script&lang=js"
export * from "./CustomDatabasePage.vue?vue&type=script&lang=js"
import style0 from "./CustomDatabasePage.vue?vue&type=style&index=0&id=63e1cbf4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e1cbf4",
  null
  
)

export default component.exports